import React, {FC, useEffect, useMemo, useState} from "react";
import {API, Endpoints, Project, ProjectAPI, Tag} from "@brg/api";
import EditIcon24 from "../../../icons/EditIcon24";
import styled from "styled-components";
import {ShareIcon} from "../../../icons/projectToolsWithResize/ShareIcon";
import {HintTooltip} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {AppTester} from "../../../../supporting";
import {ProfileRole, useProfile} from "@brg/auth";
import {HsePolicies} from "../../../constants/HsePolicies";
import {isExpert, isExpertByPolicy} from "../../../helpers/utils/TagsUtils";
import {bProfile} from "../../../../core/utils/bProfile";
import {useModal} from "../../../../core";
import {AGEYTOMESH_TAG_ID} from "../../../constants/misc";
import {MAX_PLACES_TAG_COUNT, MAX_TAG_COUNT} from "../../projectEdit/constants";

const EditIconWrapper = styled.div`
    //position: absolute;
    //top: 0;
    //right: -40px;
    cursor: pointer;
`

export const TagsEditor: FC<{ project: Project, setProject: (project: Project) => void, projectSource: Project<'Global'>, setProjectSource: (project: Project<'Global'>) => void }>
    = ({ project, setProject, projectSource, setProjectSource }) => {

    const { t, i18n } = useTranslation()
    const isGeo = AppTester.isGeograffee();
    const isSuperPuper = AppTester.isSuperPuper();
    const onWhiteBg = !isGeo && !isSuperPuper;
    const profile = useProfile();
    const modal = useModal()
    const [tags, setTags] = useState<any>(undefined)

    useEffect(() => {
        if (!project?.tags || tags !== undefined) return;
        setTags(project.tags)

    }, [tags, project]);

    const projectTags = useMemo(() => {
        if (!tags) return []
        // @ts-ignore
        return tags.filter(x => !x?.isEducationTag)
    }, [tags])
    const requiredTags = useMemo(() => {
        if (!tags) return []
        // @ts-ignore
        return tags.filter(x => x?.isEducationTag)
    }, [tags])

    const moderatedTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_editor_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_editor_prefix}`, ''))
        .map(x => x.split('_')?.[0] || '')
        .filter(x => !!x);

    const canEdit = useMemo(() => {
        if (bProfile.isModer(profile) || bProfile.isSuperModer(profile)) return true;
        if (!!moderatedTagsByPolicy?.length) return true

        return false;
    }, [profile, projectTags])

    if (!canEdit) return null

    return <EditIconWrapper>
        <HintTooltip text={t("hints.edit_tags")} z={8} noArrow positionY="top"
                     onWhiteBg={onWhiteBg}>
            <EditIcon24 onClick={() => {
                modal.show('tags', {
                    isEdit: true,
                    isTagEditor: true,
                    educational: false,
                    value: [...(tags || [])],
                    maxEducationalTags: requiredTags?.length > 0 ? 0 : 1,
                    maxProjectTags: MAX_TAG_COUNT,
                    maxPlacesTags: MAX_PLACES_TAG_COUNT,
                    editableTags: moderatedTagsByPolicy,
                    onChange: (tagsRaw: Tag[]) => {
                        const tagsIds = tagsRaw.map(tag => tag.tagId)
                        if (tagsIds.length) {
                            API.request()
                                .endpoint(Endpoints.tagsMnePw)
                                .url('/api/Tags/GetTags')
                                .addQuery('tagIds', tagsIds)
                                .lang(i18n.language)
                                .send()
                                .then((v) => v.json())
                                .then((json) => {
 /*                                   setTags((prev: any) => prev.map((tag: any) => {
                                        const translatedTag = json.find((x: any) => x.tagId === tag.tagId)
                                        return translatedTag || tag
                                    }))*/
                                    setProjectSource({...projectSource, tags: json})
                                })
                        }
                        setProject({...project, tags: tagsRaw});
                        setTags(tagsRaw)
                        API.request()
                            .endpoint(Endpoints.geograffee)
                            .url('/api/Project/UpdateTagsForProject')
                            .post()
                            .body(
                                {
                                    "projectId": projectSource?.projectId || '',
                                    "tagsToChange": tagsIds
                                })
                            .send()
                    },
                })
            }}/>
        </HintTooltip>

    </EditIconWrapper>
}import React, {FC, useEffect, useMemo, useState} from "react";
import {API, Endpoints, Project, ProjectAPI, Tag} from "@brg/api";
import EditIcon24 from "../../../icons/EditIcon24";
import styled from "styled-components";
import {ShareIcon} from "../../../icons/projectToolsWithResize/ShareIcon";
import {HintTooltip} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {AppTester} from "../../../../supporting";
import {ProfileRole, useProfile} from "@brg/auth";
import {HsePolicies} from "../../../constants/HsePolicies";
import {isExpert, isExpertByPolicy} from "../../../helpers/utils/TagsUtils";
import {bProfile} from "../../../../core/utils/bProfile";
import {useModal} from "../../../../core";
import {AGEYTOMESH_TAG_ID} from "../../../constants/misc";
import {MAX_PLACES_TAG_COUNT, MAX_TAG_COUNT} from "../../projectEdit/constants";

const EditIconWrapper = styled.div`
    //position: absolute;
    //top: 0;
    //right: -40px;
    cursor: pointer;
`

export const TagsEditor: FC<{ project: Project, setProject: (project: Project) => void, projectSource: Project<'Global'>, setProjectSource: (project: Project<'Global'>) => void }>
    = ({ project, setProject, projectSource, setProjectSource }) => {

    const { t, i18n } = useTranslation()
    const isGeo = AppTester.isGeograffee();
    const isSuperPuper = AppTester.isSuperPuper();
    const onWhiteBg = !isGeo && !isSuperPuper;
    const profile = useProfile();
    const modal = useModal()
    const [tags, setTags] = useState<any>(undefined)

    useEffect(() => {
        if (!project?.tags || tags !== undefined) return;
        setTags(project.tags)

    }, [tags, project]);

    const projectTags = useMemo(() => {
        if (!tags) return []
        // @ts-ignore
        return tags.filter(x => !x?.isEducationTag)
    }, [tags])
    const requiredTags = useMemo(() => {
        if (!tags) return []
        // @ts-ignore
        return tags.filter(x => x?.isEducationTag)
    }, [tags])

    const moderatedTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_editor_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_editor_prefix}`, ''))
        .map(x => x.split('_')?.[0] || '')
        .filter(x => !!x);

    const canEdit = useMemo(() => {
        if (bProfile.isModer(profile) || bProfile.isSuperModer(profile)) return true;
        if (!!moderatedTagsByPolicy?.length) return true

        return false;
    }, [profile, projectTags])

    if (!canEdit) return null

    return <EditIconWrapper>
        <HintTooltip text={t("hints.edit_tags")} z={8} noArrow positionY="top"
                     onWhiteBg={onWhiteBg}>
            <EditIcon24 onClick={() => {
                modal.show('tags', {
                    isEdit: true,
                    isTagEditor: true,
                    educational: false,
                    value: [...(tags || [])],
                    maxEducationalTags: requiredTags?.length > 0 ? 0 : 1,
                    maxProjectTags: MAX_TAG_COUNT,
                    maxPlacesTags: MAX_PLACES_TAG_COUNT,
                    editableTags: moderatedTagsByPolicy,
                    onChange: (tagsRaw: Tag[]) => {
                        const tagsIds = tagsRaw.map(tag => tag.tagId)
                        if (tagsIds.length) {
                            API.request()
                                .endpoint(Endpoints.tagsMnePw)
                                .url('/api/Tags/GetTags')
                                .addQuery('tagIds', tagsIds)
                                .lang(i18n.language)
                                .send()
                                .then((v) => v.json())
                                .then((json) => {
 /*                                   setTags((prev: any) => prev.map((tag: any) => {
                                        const translatedTag = json.find((x: any) => x.tagId === tag.tagId)
                                        return translatedTag || tag
                                    }))*/
                                    setProjectSource({...projectSource, tags: json})
                                })
                        }
                        setProject({...project, tags: tagsRaw});
                        setTags(tagsRaw)
                        API.request()
                            .endpoint(Endpoints.geograffee)
                            .url('/api/Project/UpdateTagsForProject')
                            .post()
                            .body(
                                {
                                    "projectId": projectSource?.projectId || '',
                                    "tagsToChange": tagsIds
                                })
                            .send()
                    },
                })
            }}/>
        </HintTooltip>

    </EditIconWrapper>
}